var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"related-products--view"}},[_c('portal',{attrs:{"to":_vm.portalId}},[(_vm.selectedProductId)?_c('RelatedProducts',{key:_vm.selectedProductId,attrs:{"productId":_vm.selectedProductId,"title":_vm.title}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }